import { useCallback } from 'react';
import { prop } from 'ramda';
import { scrollService } from 'js/services/scroll.service';
import { useAppSelector } from 'js/store/hooks';
import { useIsPageInPopupUrl } from 'js/components/system/Page/hooks';

export const useScrollToComponentTop = (elementRef) => {
    const headerHeight = useAppSelector(prop('headerHeight'));
    const isPageInPopupUrl = useIsPageInPopupUrl();

    return useCallback(() => {
        const element = elementRef?.current?.closest('.fn-portlet-wrapper') || elementRef?.current;

        if (!element) {
            return;
        }

        if (isPageInPopupUrl()) {
            element.scrollIntoView();

            return;
        }

        const { documentElement, body } = document;
        const { top } = element.getBoundingClientRect();

        // 14px - indent for better visibility
        scrollService.scrollTo(top + (documentElement.scrollTop || body.scrollTop) - headerHeight - 14);
    }, [isPageInPopupUrl, elementRef, headerHeight]);
};
